import Modal, {ModalProps} from 'react-bootstrap/Modal';
import React, {useEffect, useState} from "react";
import axios from "axios";
import {useAppUniqueToken} from "../../hooks/useAppUniqueToken";
import {useLocation, useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {toast} from "react-custom-alert";

const FiscalCodeConfirmation = ({dataField, ...props}: ModalProps)  => {
    const { t } = useTranslation();


    const handleConfirm = () => {
        toast.success(t('OK'));
    };


    return (

        <Modal
            {...props}
            centered
            backdrop="static"
            keyboard={false}
        >
            <Modal.Body>
                <h4><b>{t('captions.warning')}</b></h4> <br />
                Il codice fiscale <b>{dataField}</b> risulta già essere utilizzato per un'altra richiesta di adesione, 
                controlla bene i dati inseriti e prosegui nell'inserimento.<br />
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn_1 green" onClick={props.onHide}>{t('captions.close')}</button>
            </Modal.Footer>
        </Modal>
    );
};

export default FiscalCodeConfirmation;
